import { store } from './tracking-context-store';

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 *
 * User is passing through the payment authentication flow which might result in 3DS2 challenge.
 * @param {object} context with any data that will be stored on the Track service.
 * @param {Function} fn which result will be wrapped in promise.
 *  After this promise fulfills context will reset to null
 */
export const withContext = <T = void>(
  context: Record<string, unknown>,
  fn: () => Promise<T>,
): Promise<T> => {
  store.setState({ context });

  // fn() might not return a promise so wrap it in one to ensure we
  // can always finally() on it.
  //
  // This does mean withContext always returns a promise that you can
  // chain on, but it can't be used in synchronous flows.
  return Promise.all([fn()])
    .then(([result]) => result)
    .finally(() => {
      store.setState({ context: null });
    });
};
